<template>
  <div class="mt-3">
    <!-- ---------- -->
    <!-- BUTTONS    -->
    <!-- ---------- -->
    <div class="col mt-3">
      <!-- ------------ -->
      <!--    exit      -->
      <!-- ------------ -->
      <div class="row d-flex justify-content-center">
        <button type="button"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center">
          <ToolTip text="Save & Exit" position="right">
            <img :src="exitImg" @click="exitHandler()" height="48" width="48" alt="exit image" />
          </ToolTip>
        </button>
      </div>
      <!-- ------------ -->
      <!--      add     -->
      <!-- ------------ -->
      <!-- <p style="color:red;">{{ canAdd }}</p> -->
      <div class="d-flex justify-content-center">
        <button type="button" :disabled="!canAdd"
          class="mt-2 mb-2 btn btn-xl btn-primary btn-circle d-flex justify-content-center align-items-center"
          @click="addAdj()">
          <ToolTip text="Add Adjustment" position="right">
            <i class="bi bi-plus" style="color: white; font-size: 5em"></i>
          </ToolTip>
        </button>
      </div>
      <!-- -------------------- -->
      <!--    end of buttons    -->
      <!-- -------------------- -->
    </div>
  </div>
</template>

<script>

import ToolTip from '../components/ToolTip.vue'
import exitImg from '../assets/images/bbExit100.png'

//==========================================================
// scripts
//---------
export default {
  name: 'CharacterAdjustmentsButtonsPanel',
  components: {
    ToolTip,
  },
  // setup() {
  //   const emitter = inject('emitter');
  //   return { emitter };
  // },
  //========================================================
  // props
  //-------
  props: {
    canAdd: {
      type: Boolean,
      required: true,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      delete: false,
      exitImg,
      originalAdjs: [],
    }
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //------------------------------------
    // exit handler (return to sheet view)
    //------------------------------------
    exitHandler() {
      this.$emit('close');
    },
    //-------------------------------
    // add adj (return to adjs view)
    //-------------------------------
    addAdj() {
      this.emitter.emit('add-adjustment-row')
    },
  },
}
</script>
